module.exports = __webpack_public_path__ + "img/00010.9437acd3.webp";